import api from '@/shared/api/api';
import {
  HighlightItem,
  UpdateHighlightOrderRequest,
  UpdateHighlightOrderResponse,
  AvailableItem,
  AddItemsResponse,
} from '../types/highlight.types';

export class HighlightService {

  static async getHighlightItems(sectionKey: string): Promise<HighlightItem[]> {
    const response = await api<HighlightItem[]>({
      method: 'GET',
      url: `/v1/highlights/${sectionKey}`,
    });
    return response;
  }

  static async updateHighlightOrder(
    sectionKey: string,
    items: UpdateHighlightOrderRequest[]
  ): Promise<UpdateHighlightOrderResponse> {
    const response = await api<UpdateHighlightOrderResponse>({
      method: 'PATCH',
      url: `/v1/highlight/${sectionKey}`,
      data: items,
    });
    return response;
  }
  static async getAvailableItems(sectionKey: string, search?: string): Promise<AvailableItem[]> {
    if (!sectionKey) return [];
    const response = await api<AvailableItem[]>({
      method: 'GET',
      url: `/v1/highlight/${sectionKey}/available`,
      params: {
        search,
      },
    });
    return response;
  }

  static async addItemsToSection(
    sectionKey: string,
    itemIds: UpdateHighlightOrderRequest[]
  ): Promise<AddItemsResponse> {
    const response = await api<AddItemsResponse>({
      method: 'PATCH',
      url: `/v1/highlight/${sectionKey}`,
      data: itemIds,
    });
    return response;
  }

  static async removeItemsFromSection(
    sectionKey: string,
    itemsToRemove: UpdateHighlightOrderRequest[]
  ): Promise<UpdateHighlightOrderResponse> {
    const response = await api<UpdateHighlightOrderResponse>({
      method: 'PATCH',
      url: `/v1/highlight/${sectionKey}`,
      data: itemsToRemove,
    });
    return response;
  }
}
